import type { OrderItemUnit } from '../types/api/order-item'

export const RIBBON_PRODUCT_TYPE_SLUG = 'ribbon'

export const RIBBON_ORDER_ITEM_UNIT: OrderItemUnit = 'roll'
